import React, { Fragment } from 'react';

import styles from './NavigationSidebarStyles';

import ChevronBlueIcon from 'buyside/svgs/chevron_blue.svg';

export const SidebarLink = ({ children, displayName, url, active = false }) => {
  const linkStyle = `${active ? styles.activeLink : ''} ${styles.link}`;

  const linkContent = (
    <Fragment>
      {active ? <ChevronBlueIcon className={styles.chevron} /> : ''}
      {displayName}
    </Fragment>
  );

  if (typeof children === 'function') {
    // render prop
    return children({ linkStyle, linkContent });
  }

  return (
    <a className={linkStyle} href={url}>
      {linkContent}
    </a>
  );
};

export const Section = ({ title, children }) => {
  return (
    <div>
      <h5 className={styles.sectionTitle}>{title}</h5>
      {children}
    </div>
  );
};

const NavigationSidebar = ({ children, joyrideTarget }) => {
  return (
    <nav className="navbarContainer" data-joyride-target={joyrideTarget}>
      {children}
    </nav>
  );
};

export default NavigationSidebar;
